module.exports = __webpack_public_path__ + "static/img/person.fda48b0e.png";